import { IsString, IsOptional, IsArray } from 'class-validator';

/**
 * Workspace Context for AI Agents
 * Stored in workspaces.context (JSONB)
 */
export interface WorkspaceContext {
  /** Industry/sector (e.g., "Tool Manufacturing", "Healthcare", "E-commerce") */
  industry?: string;

  /** Company size (e.g., "250 employees", "50-100 employees") */
  size?: string;

  /** Physical locations (e.g., ["Ohio Plant 1", "Ohio Plant 2", "Remote"]) */
  locations?: string[];

  /** Detailed description of the business */
  description?: string;

  /** Primary use case for OptiDev (e.g., "Production dashboards", "Analytics") */
  primaryUseCase?: string;
}

/**
 * DTO for updating workspace context
 */
export class WorkspaceContextDto {
  @IsString()
  @IsOptional()
  industry?: string;

  @IsString()
  @IsOptional()
  size?: string;

  @IsArray()
  @IsString({ each: true })
  @IsOptional()
  locations?: string[];

  @IsString()
  @IsOptional()
  description?: string;

  @IsString()
  @IsOptional()
  primaryUseCase?: string;
}
